/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const getFormValues = (form: HTMLFormElement) => {
  const formData: any = new FormData(form);
  const result = Object.fromEntries(formData);
  return result;
};

export const getFormErrors = (form: HTMLFormElement) => {
  const formData: any = new FormData(form);

  const data = Object.fromEntries(formData);

  const result = Object.entries(data).reduce((result, [key]) => {
    // @ts-ignore
    const field = form.elements[key];

    return field?.validationMessage
      ? { ...result, [key]: field.validationMessage }
      : { ...result };
  }, {});

  return result;
};
